"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetICService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const practice_auth3_web_1 = require("@branch-ts/practice-auth3-web");
const biome_ai_web_1 = require("@branch-ts/biome-ai-web");
const practice_probe_client_1 = require("@branch-ts/practice-probe-client");
const idps_consensus_1 = require("@branch-ts/idps-consensus");
const practice_idps_web_1 = require("@branch-ts/practice-idps-web");
const seqop_consensus_1 = require("@branch-ts/seqop-consensus");
const verset_consensus_1 = require("@project/verset_consensus");
const feature_1 = require("./service.Verset/feature");
const service_VersetBusinessGuide_1 = require("./service.VersetBusinessGuide");
const service_VersetIDPS_1 = require("./service.VersetIDPS");
const service_VersetProbe_1 = require("./service.VersetProbe");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
const service_VersetScopedContent_1 = require("./service.VersetScopedContent");
const service_VersetVerse_1 = require("./service.VersetVerse");
const service_VersetWorkerFacility_1 = require("./service.VersetWorkerFacility");
const versetProductPrompt = "You are currently working in a product named \"verset.io\", you can also call it \"Verset\".";
let VersetICService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetICService = class {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetICService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        constructor(option) {
            this.option = option;
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                SessionService: practice_auth3_web_1.SessionService,
                VersetBusinessGuideService: service_VersetBusinessGuide_1.VersetBusinessGuideService,
                VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService,
                VersetScopedContentService: service_VersetScopedContent_1.VersetScopedContentService,
                VersetVerseService: service_VersetVerse_1.VersetVerseService,
                VersetIDPSService: service_VersetIDPS_1.VersetIDPSService,
                VersetProbeService: service_VersetProbe_1.VersetProbeService,
                VersetWorkerFacilityService: service_VersetWorkerFacility_1.VersetWorkerFacilityService,
            });
            this.main = null;
            this.mediator = null;
            this.scopeURI = null;
            this.threadContainer = null;
            this.threadContainerAccess = null;
        }
        get server() {
            return this.deps.VersetRequireLoginService.server;
        }
        get rpc() {
            return this.server.rpcs.VersetUserIntelligenceCenterService;
        }
        get intelligenceCenter() {
            return this.main;
        }
        async resolveDefaultIterator() {
            const [result] = await this.server.rpcs.VersetUserLLMRouteService.getMyAvailableIterators();
            return result?.default || result?.iterators?.[0]?.id || undefined;
        }
        async makeEnvironment(option) {
            const agreement = this.deps.VersetRequireLoginService.agreement;
            const fileSystemContext = option.idps.asFileSystemContext();
            return [{
                    environment: {
                        ...(0, biome_ai_web_1.createLocalNotificationEnvironment)(),
                        ...this.main?.sprint.environment(option.idps),
                        internet: {
                            internetProvider: this.server.rpcs.VersetUserInternetService,
                        },
                        browser: this.option.browser,
                        idps: {
                            idpsProvider: (uri) => {
                                return seqop_consensus_1.MediatorRegistryMechanism.ensure({
                                    uri,
                                });
                            },
                        },
                        verse: {
                            verseProvider: (uri) => {
                                return seqop_consensus_1.MediatorRegistryMechanism.ensure({
                                    uri,
                                });
                            },
                        },
                        sc: {
                            scProvider: (uri) => {
                                return this.deps.VersetScopedContentService.getMediator({
                                    uri,
                                });
                            },
                        },
                        terminals: {
                            probes: () => this.deps.VersetProbeService.getProbeInventory(),
                            probe: (option) => this.deps.VersetProbeService.requestProbe(option),
                            resolveProbeHost: (option) => this.deps.VersetProbeService.resolveProbeHost(option),
                            resolveProbeTerminal: (option) => this.deps.VersetProbeService.resolveProbeTerminal(option),
                            endpoints: () => this.deps.VersetProbeService.getTerminalFileSystemBindings(),
                            hostExecEndpoints: () => this.deps.VersetProbeService.getHostExecFileSystemBindings(),
                        },
                        mcp: {
                            servers: () => (0, practice_probe_client_1.getMcpServers)(this.deps.VersetProbeService.probeSessionManager),
                            resolve: (server) => (0, practice_probe_client_1.resolveMcpAccess)(this.deps.VersetProbeService.probeSessionManager, server),
                            bucketURI: agreement.particulars.versetWebapp.bucketURI,
                        },
                        fs: {
                            fileSystemContext,
                            bucketURI: agreement.particulars.versetWebapp.bucketURI,
                            resolveUtilAccess: (to) => this.deps.VersetProbeService.resolveUtilAccess(to),
                        },
                    },
                }];
        }
        registerICMediator(vendor) {
            seqop_consensus_1.MediatorRegistryMechanism.register({
                name: `${vendor}+ic+ic`,
                registry: (option) => {
                    const scopeInfo = idps_consensus_1.ICProtocol.ICScopeURI.parse(option.uri);
                    if (!scopeInfo || scopeInfo.vendor !== vendor) {
                        return null;
                    }
                    const provider = new seqop_consensus_1.ReconnectingArbitratorProvider(async () => {
                        const [result, reason, ...errors] = await this.getIntelligenceCenterProvider({
                            uri: option.uri,
                        });
                        if (reason || !result?.provider) {
                            throw new Error(reason || errors?.[0]?.message || "Failed to get intelligence-center provider");
                        }
                        return result.provider;
                    }, this.server.authorizedConnection);
                    const mediator = new idps_consensus_1.ICMediator({
                        arbitrator: provider,
                        uri: option.uri,
                    });
                    mediator.shouldCacheLocally = true;
                    return provider.own(mediator);
                },
            });
        }
        async initialize() {
            const agreement = this.deps.VersetRequireLoginService.agreement;
            const vendor = agreement.vendor;
            const mainICScopeURI = (agreement.particulars.versetWebapp.ic?.userMainICScopeURI || null);
            console.log("DebugICWire: VersetICService.initialize start", {
                vendor,
                mainICScopeURI,
            });
            if (!mainICScopeURI) {
                console.log("DebugICWire: VersetICService.initialize skip no-main-ic-scope");
                return;
            }
            const defaultIterator = await this.resolveDefaultIterator();
            console.log("DebugICWire: VersetICService.initialize iterator", {
                defaultIterator,
            });
            this.registerICMediator(vendor);
            console.log("DebugICWire: VersetICService.initialize mediator-registered", {
                vendor,
                mainICScopeURI,
            });
            const [spaceProviderResult, spaceProviderReason, ...spaceProviderErrors] = await this.deps.VersetIDPSService.getMainIdpSpaceProvider();
            if (spaceProviderReason || !spaceProviderResult?.provider) {
                console.error("DebugICWire: VersetICService.initialize failed-main-idps-space-provider", {
                    spaceProviderReason,
                    error: spaceProviderErrors?.[0]?.message,
                });
                throw new Error(spaceProviderReason || spaceProviderErrors?.[0]?.message || "Failed to get main idps space provider");
            }
            const bindingIdpsSpace = spaceProviderResult.provider;
            const deepWorkDefaultDutyURI = idps_consensus_1.GuildProtocol.DutyURI.builtIn({
                vendor,
                name: "verset-deep-work",
            });
            const reactor = new idps_consensus_1.ExchangeReactor({
                exchange: this.deps.VersetBusinessGuideService.gateLLMExchange(this.server.rpcs.VersetUserLLMRouteService, { source: verset_consensus_1.VersetProtocol.ProductName.intelligenceCenter }),
            });
            const threadContainer = new idps_consensus_1.IdpsThreadContainer({
                uri: idps_consensus_1.IDPSProtocol.ThreadContainerURI.build({
                    vendor,
                    id: "browser-tab-local",
                }),
                makeEnvironment: this.makeEnvironment.bind(this),
                reactor,
            });
            const threadContainerAccess = new idps_consensus_1.ThreadContainerDirectAccess({
                container: threadContainer,
            });
            const mediator = seqop_consensus_1.MediatorRegistryMechanism.ensure({
                uri: mainICScopeURI,
            });
            console.log("DebugICWire: VersetICService.initialize mediator-ensured", {
                uri: mainICScopeURI,
                readyState: mediator.ready.readyState,
            });
            if (mediator.ready.readyState === "pending") {
                console.log("DebugICWire: VersetICService.initialize mediator-init", {
                    uri: mainICScopeURI,
                });
                mediator.constructor["init"](mediator);
            }
            await mediator.ready.wait();
            console.log("DebugICWire: VersetICService.initialize mediator-ready", {
                uri: mainICScopeURI,
            });
            const intelligenceCenter = new practice_idps_web_1.IntelligenceCenter({
                mediator,
                procedureRegistry: idps_consensus_1.IdpsProcedureRegistryMechanism.ensure(this.deps.SessionService.situations.get("auth")),
                vendor,
                productPrompt: versetProductPrompt,
                threadRoutes: [{
                        // This container is the terminal route. Going through the
                        // integrated accessor recurses once IntelligenceCenter.main
                        // points to this IC's own thread manager.
                        access: threadContainerAccess,
                        containerURI: threadContainer.uri,
                        kind: "browser-tab-local",
                        priority: 0,
                    }],
                localIdpsSpace: this.deps.VersetWorkerFacilityService.sessionIdpsSpace,
                bindingIdpsSpace: bindingIdpsSpace,
                bindingIdpsDefaults: {
                    data: {
                        namespace: vendor,
                    },
                    purpose: "bac",
                    digestIterator: defaultIterator,
                    digestLimit: 32,
                    defaultDutyURI: deepWorkDefaultDutyURI,
                    iterator: defaultIterator,
                },
                notableAffair: this.deps.VersetIDPSService.notableAffairAccumulator,
            });
            intelligenceCenter.instantChat.setMakeIdpExplorer(this.deps.VersetIDPSService.makeIdpExplorer.bind(this.deps.VersetIDPSService));
            const mainVerse = this.deps.VersetVerseService.main;
            if (mainVerse) {
                intelligenceCenter.addVerseContext(mainVerse);
                console.log("DebugICWire: VersetICService.initialize main-verse-bound", {
                    verseURI: mainVerse.uri,
                });
            }
            else {
                console.log("DebugICWire: VersetICService.initialize no-main-verse");
            }
            this.main = intelligenceCenter;
            this.mediator = mediator;
            this.scopeURI = mainICScopeURI;
            this.threadContainer = threadContainer;
            this.threadContainerAccess = threadContainerAccess;
            (0, feature_1.IntelligenceCenterURIIntegrationFeature)({
                scopeURI: mainICScopeURI,
                intelligenceCenter,
            });
            console.log("DebugICWire: VersetICService.initialize ready", {
                scopeURI: mainICScopeURI,
                threadContainerURI: threadContainer.uri,
            });
        }
        async createIntelligenceCenter(option) {
            return await this.rpc.createIntelligenceCenter(option);
        }
        async getIntelligenceCenter(option) {
            return await this.rpc.getIntelligenceCenter(option);
        }
        async listMyIntelligenceCenters(option = {}) {
            return await this.rpc.listMyIntelligenceCenters(option);
        }
        async getIntelligenceCenterProvider(option) {
            return await this.rpc.getIntelligenceCenterProvider(option);
        }
        destroy() {
            this.main?.destroy();
        }
    };
    return VersetICService = _classThis;
})();
exports.VersetICService = VersetICService;
